<ion-content>
  <div class="listing-list">
    <div class="add-listing-wrapper">
      <button type="button" class="cnt-button" data-test="add-property-button" (click)="onAddListing()">
        <span class="cnt-button-icon add-button">
          <ion-icon name="add"></ion-icon>
        </span>
        <span class="cnt-button-copy">Add Property</span>
      </button>

      <div class="filtered-section">
        <div class="filtered-text">Filters:</div>
        <button
          type="button"
          class="cnt-button"
          (click)="toggleHost()"
          [ngClass]="{ 'selected-primary': showListings }"
        >
          <span class="cnt-button-icon _24px host">
            <span class="html-embed w-embed">
              <curbnturf-map-icons type="pricePinFilled" [primary]="!showListings" [white]="showListings">
              </curbnturf-map-icons>
            </span>
          </span>
        </button>

        <button
          type="button"
          class="cnt-button"
          (click)="toggleBoondock()"
          [ngClass]="{ 'selected-green': showBoondock }"
        >
          <span class="cnt-button-icon">
            <span class="html-embed w-embed">
              <curbnturf-map-icons type="boondockPinLarge" [green]="!showBoondock" [white]="showBoondock">
              </curbnturf-map-icons>
            </span>
          </span>
        </button>

        <button type="button" class="cnt-button" (click)="togglePoi()" [ngClass]="{ 'selected-primary': showPoi }">
          <span class="cnt-button-icon">
            <span class="html-embed w-embed">
              <curbnturf-map-icons type="boondockPinLarge" [primary]="!showPoi" [white]="showPoi">
              </curbnturf-map-icons>
            </span>
          </span>
        </button>
      </div>
    </div>
  </div>

  <div class="profile-warning ion-padding ion-margin" *ngIf="profileMessages.length > 0">
    Your profile is incomplete! You will need to complete your profile before you can publish your properties.
    <ul class="ion-margin">
      <li *ngFor="let message of profileMessages">{{ message }}</li>
    </ul>
    <ion-button [routerLink]="'/user-dashboard/user-profile'">Complete Profile</ion-button>
  </div>

  <div *ngIf="connectionStatus?.connected === false" class="warning-notice">
    <h4>Offline Mode</h4>
    Some items may not be accurate due to cached data.
  </div>

  <ion-list>
    <ion-item *ngFor="let listing of limitedListings; trackBy: trackByString" lines="none">
      <curbnturf-listing-list-item [listing]="listing" (listingUpdated)="onListingUpdated(listing)">
      </curbnturf-listing-list-item>
    </ion-item>
    <ion-item *ngFor="let boondock of limitedBoondocks; trackBy: trackByString" lines="none">
      <curbnturf-boondock-list-item [boondock]="boondock"> </curbnturf-boondock-list-item>
    </ion-item>
    <ion-item *ngFor="let poi of limitedPois; trackBy: trackByString" lines="none">
      <curbnturf-poi-list-item [poi]="poi"> </curbnturf-poi-list-item>
    </ion-item>
  </ion-list>

  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles"></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <ng-template *ngIf="!listings || listings?.length === 0">
    <h3>No properties found.</h3>
  </ng-template>
</ion-content>
